// this file added for individual by Bearer Web Developer
import React from 'react';
import styles from './createAccount.module.scss';
import { useAppState } from '../../../states/app-state';
import { SigninSituation } from '../../../states/signinState';
import { Button } from '@mui/material';
import MobileForm from '../mobileForm';

const CreateAccount: React.FunctionComponent = () => {
    const appState = useAppState();
    const { signin } = appState;

    const handleClose = () => {
        signin.setSituation(SigninSituation.Login);
    }
    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <h2>Create Account</h2>
                <Button className={styles.back} disableRipple={true} onClick={handleClose}>
                    <img src="/back.png" alt="back" />
                </Button>
            </div>
            <h3>First, please verify your mobile number.</h3>
            <p>Your number needs to be verified to continue and your process will be saved!</p>
            <MobileForm sign={'signup'} />
        </div>
    )
};

export default CreateAccount;